import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import { Search, X } from "lucide-react";
import { useDataTable } from "@/components/custom/table/data-table";
import { DataTableViewOptions } from "@/components/custom/table/data-table-view-options";

export const SearchToolbar = () => {
  const table = useDataTable();
  const isFiltered = table.getState().columnFilters.length > 0;

  return (
    <div className="flex items-center gap-4">
      <div className="relative max-w-sm flex-1">
        <Search className="absolute top-2 left-2 h-4 w-4 text-muted-foreground" />
        <Input
          className="h-8 pl-8"
          onChange={(event) =>
            table.getColumn("label")?.setFilterValue(event.target.value)
          }
          placeholder="Search by label..."
          // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
          value={(table.getColumn("label")?.getFilterValue() as string) ?? ""}
        />
      </div>
      {!!isFiltered && (
        <Button
          className="h-8 px-2 lg:px-3"
          onClick={() => {
            table.resetColumnFilters();
            table.resetSorting();
          }}
          variant="warning"
        >
          Reset
          <X className="ml-2 size-4" />
        </Button>
      )}

      <DataTableViewOptions table={table} />
    </div>
  );
};
